<template>
  <div>
    <wc-page-title title='Budgets'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='6'>
          <wc-data-box
            title='All Budgets'
            :titleIcon='headerData.icon'
            :titleIconColor='headerData.color'
            :loading='isLoading'
            showAdd
            @add='add'
          >
          <v-data-table
            dense
            :items='budgets'
            :headers='headers'
            @click:row='openBudget'
            sort-by='start_date'
            sort-desc
          >
            <template v-slot:item.description='{ item }'>
              {{ item.description }}
              <v-chip xSmall v-if='item.is_active' color='success'>Active</v-chip>
            </template>
            <template v-slot:item.start_date='{ item }'>
              {{ item.start_date | shortDate }}
            </template>
            <template v-slot:item.end_date='{ item }'>
              {{ item.end_date | shortDate }}
            </template>
          </v-data-table>
          </wc-data-box>
        </v-col>
        <!-- <v-col cols='12' md='6'>
          <categories></categories>
        </v-col> -->
      </v-row>
    </v-container>

    <wc-dialog
      :showDialog='showDialog'
      title='Create a new budget'
      :icon='headerData.icon'
      width='400'
      saveText='Create'
      @save='create'
      @cancel='showDialog = false'
      :disableButtons='!isFormValid'
    >
      <v-form v-model='isFormValid' ref='form'>
        <v-text-field
          v-model='budgetCopy.description'
          label='Description'
          :rules='[rules.required]'
        ></v-text-field>
        <wc-datepicker v-model='budgetCopy.start_date'></wc-datepicker>
        <wc-datepicker v-model='budgetCopy.end_date'></wc-datepicker>
      </v-form>
    </wc-dialog>

  </div>
</template>

<script>

// import Categories from '../components/budgets/Categories'
import budgetsAPI from '../api/budgets'
import formRules from '@/mixins/formRules'
import moment from 'moment'

export default {
  name: 'budgets',
  mixins: [formRules],
  data: () => ({
    isLoading: true,
    showDialog: false,
    isFormValid: false,
    budgetCopy: {},
    headers: [
      { text: 'Description', value: 'description' },
      { text: 'Start date', value: 'start_date', width: '120', align: 'end' },
      { text: 'End date', value: 'end_date', width: '120', align: 'end' }
    ],
    budgets: []
  }),
  computed: {
    headerData () {
      return this.$store.state.icons.modules.budgets
    },
    today () {
      return moment().format('YYYY-MM-DD').toString()
    },
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.budgets = await budgetsAPI.getBudgets()
      this.isLoading = false
    },
    resetCopy () {
      this.budgetCopy.description = ''
      this.budgetCopy.start_date = this.today
      this.budgetCopy.end_date = moment(this.today).add(1, 'year').format('YYYY-MM-DD').toString()
      this.budgetCopy.is_active = false
    },
    add () {
      this.resetCopy()
      this.showDialog = true
      this.$nextTick(() => {
        this.$refs.form.resetValidation()
      })
    },
    async create () {
      this.isLoading = true
      let tmp = await budgetsAPI.createBudget(this.budgetCopy)
      this.isLoading = false
      this.openBudget(tmp)
    },
    openBudget (item) {
      this.$router.push({ name: 'BudgetOverview', params: { id: item.id } })
    }
  },
  components: {
    // 'categories': Categories
  }
}
</script>
